import { Line as B } from "@react-three/drei";
import { memo as G, useMemo as u, useCallback as c } from "react";
import { MathUtils as O, BackSide as U } from "three";
import { useRefPersistent as p } from "../../hooks/index7.js";
import { isPolygonClosed as Y } from "@project-rouge/rg-core";
import { DotFC as q } from "../dot-fc/index.js";
import { PlaneFC as H } from "../plane-fc/index.js";
import { PointListEditor as I } from "../point-list-editor/index2.js";
import { Shape as J } from "../index2.js";
import { jsxs as g, Fragment as P, jsx as a } from "react/jsx-runtime";
const no = G(function({
  onChange: D,
  points: i,
  pointColor: k = "#5e5e5e",
  midPointColor: v = "#e1f5c4",
  polygonFill: b = "#fff",
  polygonBorder: x = "#5e5e5e",
  polygonOpacity: d = 1,
  pointRadius: E = 10,
  readonly: S,
  orbit: j,
  addOnDbClick: m,
  showShape: F,
  canDeleteOpenPoly: M,
  dbClickToClose: C
}) {
  C && m && console.warn("You cant use `dbClickToClose` and `addOnDbClick` at the same time.");
  const l = Y(i), r = p({
    points: i,
    dbClickToClose: C,
    isClosed: l,
    onChange: D
  }), h = u(() => {
    const e = [];
    if (!l)
      return e;
    for (let o = 0; o < i.length - 1; o++) {
      const s = i[o], n = i[o + 1], t = s.clone().add(n).multiplyScalar(0.5);
      e.push(t);
    }
    return e;
  }, [i, l]), f = p({
    points: i,
    isClosed: l,
    midPoints: h
  }), A = c((e) => {
    const {
      onChange: o,
      isClosed: s
    } = r();
    if (!o)
      return;
    const n = f().points.slice(), t = n.length - 1;
    s && e === t && (e = 0), s && n.pop(), n.splice(e, 1), s && n.length > 2 && n.push(n[0]), o(n);
  }, []), L = c((e, o) => {
    const {
      onChange: s,
      isClosed: n
    } = r();
    if (!s)
      return;
    const t = f().points.slice();
    t[e] = o.clone(), n && (e === 0 || e === t.length - 1) && (t[0] = o.clone(), t[t.length - 1] = o.clone()), s(t);
  }, []), R = c((e) => {
    const {
      onChange: o
    } = r();
    if (!o)
      return;
    const s = f().points.slice();
    s.push(e), o(s);
  }, []), T = c((e) => {
    const {
      onChange: o,
      isClosed: s
    } = r();
    if (!o || s || e !== 0)
      return;
    const n = r().points.slice();
    n.push(n[0]), o(n);
  }, []), w = c((e) => {
    const {
      onChange: o
    } = r();
    if (!o)
      return;
    const {
      pos: s,
      i: n
    } = e.eventObject.userData, t = r().points.slice();
    t.pop(), t.splice(n + 1, 0, s.clone()), t.push(t[0]), o(t);
  }, []), y = c(() => {
    const {
      isClosed: e,
      points: o,
      dbClickToClose: s,
      onChange: n
    } = r();
    if (!n || !s || e || o.length < 3)
      return;
    const t = o.slice();
    t.push(t[0]), n(t);
  }, []);
  l && (i = i.slice(0, -1));
  const z = u(() => i.map((e) => [e.x, e.z]), [i]);
  return /* @__PURE__ */ g(P, {
    children: [!S && /* @__PURE__ */ g(P, {
      children: [/* @__PURE__ */ a(I, {
        points: i,
        onAdd: l ? void 0 : R,
        onChange: L,
        onDelete: M || i.length > 3 ? A : void 0,
        orbit: j,
        color: k,
        radius: E,
        addOnDbClick: m,
        onSelect: T,
        renderOrder: 2
      }), h.map((e, o) => /* @__PURE__ */ a(q, {
        position: e,
        radius: 10,
        color: v,
        renderOrder: 2,
        userData: {
          pos: e,
          i: o
        },
        onClick: w
      }, o)), /* @__PURE__ */ a(H, {
        onDoubleClick: y
      })]
    }), l && F && /* @__PURE__ */ a(J, {
      rotation: [90 * O.DEG2RAD, 0, 0],
      points: z,
      "material-color": b,
      "material-opacity": d,
      "material-transparent": d !== 1 && d !== void 0,
      "material-side": U
    }), i.length > 1 && /* @__PURE__ */ a(B, {
      points: r().points,
      dashed: !l,
      color: x
    })]
  });
});
export {
  no as PolygonEditor
};
//# sourceMappingURL=index.js.map
